import Isotope from 'isotope-layout';

export function productOverview() {
  const isotope = new Isotope(document.querySelector('#product-grid'), {
    itemSelector: 'li',
    percentPosition: true,
    masonry: {
      columnWidth: 'li',
      gutter: 48,
    },
  });

  if (screen.width < 768) {
    setTimeout(() => {
      isotope.layout();
    }, 100);
  }

  const buttons = document.querySelectorAll('#product-filters button');

  const typeFilter = getQueryParam('type');

  if (typeFilter) {
    isotope.arrange({ filter: `.${typeFilter}` });

    // Set the corresponding button to active
    buttons.forEach((button) => {
      if (button.getAttribute('data-filter') === `.${typeFilter}`) {
        button.setAttribute('aria-pressed', 'true');
      } else {
        button.setAttribute('aria-pressed', 'false');
      }
    });
  }

  buttons.forEach((button) => {
    button.addEventListener('click', (event) => {
      buttons.forEach((btn) => {
        btn.setAttribute('aria-pressed', 'false');
      });

      event.target.setAttribute('aria-pressed', 'true');

      isotope.arrange({ filter: event.target.getAttribute('data-filter') });
    });
  });
}

function getQueryParam(name) {
  const params = new URLSearchParams(window.location.search);
  return params.get(name);
}
